import { MtTask, MtUser, MtDriveFile } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { UserFilters, LifecyclePhaseList } from "client/store"
import * as types from "./types"


export const setTaskBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.TASK_BASE_ROUTE),
    baseRoute,
})
export const showTaskColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.TASK_COLUMN_SETTINGS),
    show,
})
export const setTasksOnSelect = (onSelect: types.TasksOnSelect) => ({
    type: inferLiteral(types.TASK_ON_SELECT),
    onSelect,
})
export const setTaskSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.TASK_SELECTED),
    selected,
})


export const setTaskList = (taskList: types.TaskList) => ({
    type: inferLiteral(types.TASK_LIST),
    taskList,
})
export const setTaskGroupedIds = (taskGroupedIds: types.TaskGroupedIds) => ({
    type: inferLiteral(types.TASK_GROUPED_IDS),
    taskGroupedIds,
})
export const setTaskSort = (sort: types.TaskSort) => ({
    type: inferLiteral(types.TASK_SORT),
    sort,
})
export const setTaskFilters = (filters: types.TaskFilters) => ({
    type: inferLiteral(types.TASK_FILTERS),
    filters,
})


export const setTaskEdit = (task: MtTask) => ({
    type: inferLiteral(types.TASK_EDIT),
    task,
})
export const setTaskAttachmentsEdit = (attachments: MtDriveFile[]) => ({
    type: inferLiteral(types.TASK_ATTACHMENTS_EDIT),
    attachments,
})
export const setTaskProjectGroupedListEdit = (taskProjectGroupedList: types.TaskList) => ({
    type: inferLiteral(types.TASK_PROJECT_GROUPED_LIST_EDIT),
    taskProjectGroupedList,
})
export const setTaskProjectGroupedIdsEdit = (taskProjectGroupedIds: types.TaskProjectGroupedIds) => ({
    type: inferLiteral(types.TASK_PROJECT_GROUPED_IDS_EDIT),
    taskProjectGroupedIds,
})
export const setTaskLifecyclePhaseListEdit = (phaseList: LifecyclePhaseList) => ({
    type: inferLiteral(types.TASK_LIFECYCLE_PHASE_LIST_EDIT),
    phaseList,
})
export const setTaskLifecyclePhaseIdsEdit = (phaseIds: types.TaskLifecyclePhaseIds) => ({
    type: inferLiteral(types.TASK_LIFECYCLE_PHASE_IDS_EDIT),
    phaseIds,
})
export const setTaskReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.TASK_RELOAD_EDIT),
    value,
})


export const setTaskAttachmentsView = (attachments: types.TaskViewAttachments) => ({
    type: inferLiteral(types.TASK_ATTACHMENTS_VIEW),
    attachments,
})


// popup menu
export const setTaskActive = (active: MtTask) => ({
    type: inferLiteral(types.TASK_ACTIVE),
    active,
})
export const setTaskPopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.TASK_POPUP_MENU_SHOW),
    show,
})
export const setTaskPopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.TASK_POPUP_MENU_TARGET),
    target,
})


export const setTaskDelegateUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.TASK_DELEGATE_USER_IDS),
    userIds,
})
export const setTaskDelegateSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.TASK_DELEGATE_SORT),
    sortColumn,
    sortOrder,
})
export const setTaskDelegateFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.TASK_DELEGATE_FILTERS),
    filters,
})
export const setTaskDelegateSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.TASK_DELEGATE_SELECTED),
    selected,
})
